import PropTypes from "prop-types";
// import { useDispatch } from "react-redux";

import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
// import Flags from "country-flag-icons/react/3x2";
import { Button, Image, Menu, MenuButton, MenuItem, MenuList, Text, useColorModeValue } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { IoLanguage } from "react-icons/io5";
import fr from "../landing_page/assets/images/fr.png";
import en from "../landing_page/assets/images/us.png";

const LanguageChanger = ({ currency }) => {
    const { i18n } = useTranslation();
    // const dispatch = useDispatch();
    const changeLanguageTrigger = e => {
        const languageCode = e.target.value;
        i18n.changeLanguage(languageCode);
    };


    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || 'fr'); // Default language

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (language) => {
        // Implement language change logic here
        setSelectedLanguage(language);
        const languageCode = language;
        i18n.changeLanguage(languageCode);
        handleClose();
    };

    // const Flag = ({ countryCode }) => {
    //     const FlagComponent = Flags[countryCode.toUpperCase()];

    //     if (!FlagComponent) {
    //         // Handle the case where the country code is not valid or not supported
    //         return null;
    //     }

    //     return <FlagComponent style={{ width: '24px', height: 'auto' }} />;
    // };


    return (

        <>
            {/* <Button
                sx={{ color: '#000000' }}
                aria-controls="language-menu"
                aria-haspopup="true"
                onClick={handleClick}
                
            >
                hi
            </Button> */}
            <Menu>
                <MenuButton w={'fit-content'} _active={'none'} _hover={"none"} background={'transparent'} color={'white'} transition="all 0.3s"
              _focus={{ boxShadow: "none" }} as={Button} rightIcon={<ChevronDownIcon />} leftIcon={<IoLanguage />}>
                    {selectedLanguage==='fr' ? "Français" : "English"}
                </MenuButton>
                <MenuList  zIndex={9999} borderColor="gray.600"
              alignItems={"center"}
              bg={useColorModeValue("gray.800", "black")}
              color="white"
              boxShadow={"3px 3px 50px #1a202c"}>
                    <MenuItem  _hover={{ bg: "blue.900", color: "white" }}
                bg={useColorModeValue("gray.800", "black")} onClick={() => handleLanguageChange('en')} style={{ display: 'flex', alignItems: 'center' }}>
                      <Image src={en} w={"25px"} mr={3}/> English

                    </MenuItem>
                    <MenuItem _hover={{ bg: "blue.900", color: "white" }}
                bg={useColorModeValue("gray.800", "black")} onClick={() => handleLanguageChange('fr')} style={{ display: 'flex', alignItems: 'center' }}>
                        <Image src={fr} w={"25px"} mr={3}/> Français

                    </MenuItem>

                </MenuList>
            </Menu>

        </>
    );
};

LanguageChanger.propTypes = {
    currency: PropTypes.shape({}),
};

export default LanguageChanger;
